import React, { useCallback } from 'react';

import GalleryDemoLayout from './GalleryDemoLayout';
import { useGalleryLightbox } from './GalleryLightbox';
import { PHOTOS } from './galleryDemoData';

/* Demo 5 — 3D tilt mosaic. Each card tilts toward the cursor in 3D with a
   moving glare. Click opens the lightbox. */
const GalleryTilt = () => {
    const lb = useGalleryLightbox(PHOTOS);

    const onMove = useCallback((e) => {
        const el = e.currentTarget;
        const r = el.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width;
        const py = (e.clientY - r.top) / r.height;
        el.style.setProperty('--rx', ((0.5 - py) * 14).toFixed(2) + 'deg');
        el.style.setProperty('--ry', ((px - 0.5) * 16).toFixed(2) + 'deg');
        el.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
    }, []);

    const onLeave = useCallback((e) => {
        const el = e.currentTarget;
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
    }, []);

    return (
        <GalleryDemoLayout
            demoLabel="Demo 5"
            kicker="3D Tilt Mosaic"
            title="Follow The Cursor"
            lead="Move your mouse across the wall — every card leans into the cursor in 3D, with a live glare. Click a card to open it full-screen."
        >
            <div className="wrap">
                <div className="gtilt">
                    {PHOTOS.map((p, i) => (
                        <button
                            type="button"
                            className={"gtilt__card reveal d" + ((i % 4) + 1)}
                            key={i}
                            onMouseMove={onMove}
                            onMouseLeave={onLeave}
                            onClick={() => lb.open(i)}
                            aria-label={`View photo: ${p.cap}`}
                        >
                            <span className="gtilt__inner">
                                <img src={p.src} alt={p.cap} loading="lazy" draggable="false" />
                                <span className="gtilt__glare" aria-hidden="true" />
                                <span className="gtilt__cap">{p.cap}</span>
                            </span>
                        </button>
                    ))}
                </div>
            </div>
            {lb.lightbox}
        </GalleryDemoLayout>
    );
};

export default GalleryTilt;
